<script setup>
import {computed, onMounted, ref} from "vue";
import store from "@/store";
import {couponConf} from "@/utils/config";
import {useRoute} from "vue-router";
import axiosApi from "@/utils/axiosApi";
import {dayjs, ElMessageBox} from "element-plus";
import {Swiper, SwiperSlide} from "swiper/vue";
// 如果需要自定义Swiper的选项，可以导入Swiper类并创建实例
import {EffectCards, Pagination} from 'swiper/modules';
import SwiperCore from "swiper"
import "swiper/css"
import 'swiper/css/pagination'
import router from "@/router";
import {copyText, gotoUrl} from "@/utils/func";

SwiperCore.use([EffectCards, Pagination]);
const isWeix = computed(() => {
  return navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1
})
const loading = ref(false)
const timer = ref(0)
const route = useRoute()
const type = computed(() => {
  let ty = store.state.coupon || route.query.type
  return couponConf[ty] || {}
})
const order = ref({})
const term = computed(() => {
  const hasCoupon = order.value?.hasCoupon
  return hasCoupon && hasCoupon.length ? dayjs(hasCoupon[0].term * 1000).format('YYYY年M月D日') : ""
})
const totalMoney = computed(() => {
  if (Object.keys(order.value) < 1) return 0;
  let number = Math.floor(parseFloat(order.value?.totala_price) / parseFloat(order.value?.face_value))
  if (number !== parseFloat(order.value?.buy_count)) {
    return parseFloat(order.value?.couponItems?.face_value) * parseInt(order.value?.buy_count);
  }
  return order.value?.totala_price
})
const couponNumber = computed(() => {
  if (Object.keys(order.value).length < 1 || order.value.hasCoupon.length < 1) return 0
  let coupons = order.value.hasCoupon.filter(its => its.is_use === 1 && Math.floor((new Date().getTime()) / 1000) < its.term)
  return coupons.length
})
onMounted(() => {
  if (!route.query.type)
    store.commit("getCoupon")

  else store.commit("setCoupon", route.query.type)
  document.title = "兑换成功"
  getOrder()
})

const getOrder = () => {
  loading.value = true;
  new axiosApi({
    encode: "site",
    method: "coupon/orderDetails",
    body: {
      ordersn: route.params.order
    }
  }).send(res => {
    loading.value = false;
    if (res.message.code === "000") {
      if (res.data.hasCoupon) {
        res.data.hasCoupon.forEach((its, inx) => {
          console.log(res.data.hasCoupon[inx])
          if (its.coupon_bag) res.data.hasCoupon[inx].coupon_bag = JSON.parse(its.coupon_bag)
        })
      }
      order.value = res.data
      let type = "jdxc"
      switch (res.data?.couponItems?.business) {
        case 'hbwl':
          type = "hkl-xmair"
          break;
        case 'hkl':
          type = res.data.pay_type === '1' ? "hkl-scal" : "hkl-xmair"
          if (!isWeix.value) {
            ElMessageBox.confirm("请在微信中打开链接识别二维码换取" + res.data?.couponItems?.name + '优惠券', "提示！", {
              confirmButtonText: '复制链接',
              cancelButtonText: '我知道了',
              type: 'warning'
            }).then(() => {
              copyText(window.location.href)
            })
          }
          break;
        case "lsq":
          type = res.data.pay_type === '1' ? "lsq-scal" : "lsq-xmair"
          break;
        case "pyf":
          type = "pyf-xmair"
          break;
        case "haoll":
          type = "hll-scal"
          break;
        case "beiguo":
          type = "beiguo-xmair"
          break;
        case "atl":
          type = "atl-scal"
          break;
        case "hibake":
          type = "hibake-scal"
          break;
        case "waijiaoguan":
          type = res.data.pay_type === '1' ? "wjg-scal" : "wjg-xmair"
          break;
        case "lanting-yuanzu":
          type = "yuanzu"
          break;
      }
      store.commit("setCoupon", type)
      if (res.data?.couponItems?.business === "lanting-yuanzu" && res?.data?.hasCoupon?.length < 1 && timer.value < 5) {
        loading.value = true;
        timer.value++;
        setTimeout(() => getOrder(), 3000);
      }
    }
  }, () => loading.value = false)
}
</script>

<template>
  <el-scrollbar class="page-pid page-success" :style="type.style" v-if="Object.keys(order).length" v-loading="loading">
    <div class="order-details-header">
      <div class="order-details-header-info">
        <div class="icon-pay">
          <el-image :src="type?.success"/>
        </div>
        <div style="line-height: 1.75">
          <h3>兑换成功！</h3>
          <div>感谢您的兑换</div>
        </div>
      </div>
      <div class="border-icon"></div>
    </div>
    <div class="order-info">
      <!--      {{ order.couponItems }}-->
      <!--      order?.couponItems?.business !== 'hbwl' && order?.couponItems?.business !== 'haoll' && order?.couponItems?.business !== 'atl'-->
      <div class="order-info-title" v-if="!['hbwl', 'haoll', 'atl'].find(its => its === order?.couponItems?.business)">
        <h3 v-if="!['hkl', 'pyf', 'beiguo', 'hibake','waijiaoguan'].find(its=>its === order?.couponItems?.business)">
          {{
            order?.couponItems?.title || order?.couponItems?.name
          }}</h3>
        <h3 v-else>{{ order?.couponItems?.name }}</h3>
        <div class="order-price">
          <sup>￥</sup><span class="order-face-value">{{ parseFloat(order?.couponItems?.face_value) }}</span>
        </div>
        <div v-if="type?.type !== 'lanting-yuanzu'">有效期：{{ term }}</div>
        <div>共{{ order?.buy_count }}张，可用{{ couponNumber }}张，合计{{ totalMoney }}元</div>
      </div>
      <div class="order-info-title" v-else>
        <h3>{{ order?.couponItems?.name }}</h3>
        <div style="text-align: justify" v-if="order?.couponItems?.business === 'hbwl'">
          <el-text>激活提示:请复制卡号和卡密至:
            <el-text type="primary">“全冀游”</el-text>
            微信小程序，点击旅游年卡-年卡激活-输入
            <el-text type="primary">卡号和卡密</el-text>
            -填写(姓名+手机号+身份证号码)信息开通年卡
          </el-text>
        </div>
        <div v-else-if="order?.couponItems?.business === 'haoll'">
          <el-text type="info">
            温馨提示：兑换成功后请于
            <el-text type="danger">60天内</el-text>
            完成绑定，短信里复制卡号+卡密后，关注并打开“好利来”公众号，点击菜单栏“服务”-“0开头卡转电子卡”-“卡包”-“绑定新实体卡”
            <el-text type="danger">粘贴卡号+卡密</el-text>
            ，点击“绑定”。
          </el-text>
        </div>
        <div v-else-if="order?.couponItems?.business === 'atl'"
             style="text-align: left;line-height: 1.45;font-weight: normal">
          <el-text type="info">
            温馨提示:“电子代金券”含卡号及密码，
            <el-text style="color: #7763AA">请点开短信内链接</el-text>
            复制“卡号及密码”→微信搜索“奥特乐”小程序→点击【礼品卡】→绑卡→输入卡号+密码→点击【合并】即为绑定成功。
          </el-text>
        </div>
      </div>
      <div class="order-qrcode" v-if="order.pay_status !== 200">
        <div class="order-info-qrcode-empty">
          订单处理中
        </div>
      </div>
      <div v-else-if="type?.type !== 'hibake' && type?.type !== 'waijiaoguan'">
        <div style="margin: 15px">
          <el-text class="tips" v-if="type?.type === 'lanting-yuanzu'">
            兑换成功后,请复制“卡号+密码”进入【元祖线上门店】微信小程序,底部菜单栏点击【礼卡绑定】→【绑定新卡】,输入卡号及密码进行绑定。
          </el-text>
        </div>
        <swiper loop class="order-qrcode" navigation :scrollbar="{ draggable: true }" :pagination="{ clickable: true }"
                v-if="order.order_status === 1">
          <swiper-slide v-for="(inx,num) in order.hasCoupon" :key="inx">
            <div
                v-if="order?.couponItems?.business !== 'hbwl' && order?.couponItems?.business !== 'haoll' && order?.couponItems?.business !== 'atl' && !/^lanting-.+/.test(order?.couponItems?.business)">
              <div class="order-info-qrcode-empty" v-if="inx.draw_status !== 2">
                订单处理中
              </div>
              <div v-else-if="inx.is_use === 1">
                <div v-if="order?.couponItems?.business !== 'hkl'">
                  <div class="barcode">
                    <el-image :src="`https://cloud.jifen360.com/barcode/${inx.code}`"/>
                  </div>
                  <div class="qrcode">
                    <el-image :src="`https://open.jifen360.com/qrcode/${inx.code}`"/>
                  </div>
                </div>
                <div v-else>
                  <div class="qrcode hkl-url">
                    <el-image :src="`https://cloud.jifen360.com/hkl/mini/${inx.code}`"/>
                  </div>
                </div>
                <h3 v-if="order?.couponItems?.business !== 'pyf'" style="padding: 0 10px;text-align: center">
                  <el-text :type="type.login === 'xm_air'?'primary':'danger'" style="color: var(--btn-color)">
                    {{
                      order?.couponItems?.business === 'hkl' ? '领取至“豪客来牛排”小程序个人账户后,到店消费，出示“豪客来牛排-买单会员码”即可使用。' : '请将此页面出示给店员进行核销'
                    }}
                  </el-text>
                </h3>
                <h3 v-else>
                  <el-text type="primary">
                    请至指定门店换取实体购物卡
                  </el-text>
                  <p>
                    <el-text type="primary">
                      1、鹿城店
                    </el-text>
                    <el-text type="primary" style="padding-left: 15px">
                      2、雷锋店
                    </el-text>
                  </p>
                </h3>
              </div>
              <div class="order-info-qrcode-empty" v-else>
                已使用
              </div>
            </div>
            <div style="text-align: justify;box-sizing: border-box;padding: 0 15px" v-else-if="order?.couponItems?.business === 'hbwl'">
              <div v-if="!inx.coupon_bag">
                <div class="code-data">
                  <div class="code-its">
                    <el-text type="primary">旅游年卡E卡编号</el-text>
                    <div>{{ inx?.code }}</div>
                  </div>
                  <el-button type="primary" round @click="copyText(inx?.code)">点击复制</el-button>
                </div>
                <div class="code-data">
                  <div class="code-its">
                    <el-text type="primary">旅游年卡E卡密码</el-text>
                    <div>{{ inx?.pwd }}</div>
                  </div>
                  <el-button type="primary" round @click="copyText(inx?.pwd)">点击复制</el-button>
                </div>
              </div>
              <div class="codes" v-else>
                <div class="code-lst-its" v-for="card in inx.coupon_bag" :key="card">
                  <div class="code-name">
                    <i class="ticket-font ticket-qiapian"></i>
                    {{ card?.name }}
                  </div>
                  <div class="code-data">
                    <div class="code-its">
                      <el-text type="primary">旅游年卡E卡编号</el-text>
                      <div>{{ card?.code }}</div>
                    </div>
                    <el-button type="primary" round @click="copyText(card?.code)">点击复制</el-button>
                  </div>
                  <div class="code-data">
                    <div class="code-its">
                      <el-text type="primary">旅游年卡E卡密码</el-text>
                      <div>{{ card?.pwd }}</div>
                    </div>
                    <el-button type="primary" round @click="copyText(card?.pwd)">点击复制</el-button>
                  </div>
                </div>
              </div>
            </div>
            <div style="text-align: justify;box-sizing: border-box;padding: 0 15px"
                 v-else-if="order?.couponItems?.business === 'haoll'">
              <!--           {{ inx }}-->
              <div class="hll-order-codes">
                <h4 class="hll-order-codes-title">
                  实体卡信息
                </h4>
                <div class="hll-order-codes-its">
                  <div class="hll-order-code">
                    <el-text type="danger">卡号：</el-text>
                    {{ inx.code }}
                  </div>
                  <div class="hll-order-btn">
                    <el-button type="danger" round size="small" @click="copyText(inx.code)">点击复制</el-button>
                  </div>
                </div>
                <div class="hll-order-codes-its">
                  <div class="hll-order-code">
                    <el-text type="danger">密码：</el-text>
                    {{ inx.pwd }}
                  </div>
                  <div class="hll-order-btn">
                    <el-button type="danger" round size="small" @click="copyText(inx.pwd)">点击复制</el-button>
                  </div>
                </div>
              </div>
            </div>
            <div style="text-align: justify;box-sizing: border-box;padding: 0 15px"
                 v-else-if="order?.couponItems?.business === 'atl'">
              <!--           {{ inx }}-->
              <div class="hll-order-codes">
                <h4 class="hll-order-codes-title">
                  实体卡信息
                </h4>
                <div class="hll-order-codes-its">
                  <div class="hll-order-code">
                    <el-text type="danger">卡号：</el-text>
                    {{ inx.code }}
                  </div>
                  <div class="hll-order-btn">
                    <el-button type="danger" round size="small" @click="copyText(inx.code)" color="#7763AA">点击复制
                    </el-button>
                  </div>
                </div>
                <div class="hll-order-codes-its">
                  <div class="hll-order-code">
                    <el-text type="danger">密码：</el-text>
                    {{ inx.pwd }}
                  </div>
                  <div class="hll-order-btn">
                    <el-button type="danger" round size="small" @click="copyText(inx.pwd)" color="#7763AA">点击复制
                    </el-button>
                  </div>
                </div>
              </div>
            </div>
            <div style="text-align: justify;box-sizing: border-box;padding: 0 15px"
                 v-else-if="/^lanting-.+/.test(order?.couponItems?.business)">

              <el-card style="margin-bottom: 15px;border-radius: 18px">
                <div class="hll-order-codes-its">
                  <div class="hll-order-code">
                    <el-text type="danger">卡号：</el-text>
                    {{ inx.code }}
                  </div>
                  <div class="hll-order-btn">
                    <el-button type="danger" round size="small" @click="copyText(inx.code)" color="#7763AA">点击复制
                    </el-button>
                  </div>
                </div>
                <div class="hll-order-codes-its">
                  <div class="hll-order-code">
                    <el-text type="danger">密码：</el-text>
                    {{ inx.pwd }}
                  </div>
                  <div class="hll-order-btn">
                    <el-button type="danger" round size="small" @click="copyText(inx.pwd)" color="#7763AA">点击复制
                    </el-button>
                  </div>
                </div>
              </el-card>
            </div>
            <el-text :type="type.login === 'xm_air'?'primary':'danger'" size="large" style="color: var(--btn-color)">
              {{ num + 1 }}/{{
                order.buy_count
              }}张
            </el-text>
          </swiper-slide>
          <div
              v-if="order?.couponItems?.business === 'haoll' || order?.couponItems?.business === 'atl' || /^lanting-.+/.test(order?.couponItems?.business)">
            <el-text type="danger">请左右滑动</el-text>
            <el-text>可查看多张卡号和卡密</el-text>
          </div>
        </swiper>
      </div>
      <div v-else class="hibake-success-box">
        <div>
          <el-text class="tips" v-if="type?.type === 'hibake'">
            温馨提示:“电子兑换码”需在60天内在“Hibake烘焙”微信小程序内兑换成产品券，产品券自兑换之日起30天内有效，过期作废，不退不补。
          </el-text>
          <el-text class="tips" v-if="type?.type === 'waijiaoguan'">
            温馨提示:请点击短信内链接复制“电子兑换码”→微信搜索“diplomat外交官箱包商城”小程序→点击【我的】→优惠券→绑定优惠券→输入复制的“电子兑换码”→完成绑定。
          </el-text>
        </div>
        <div class="hibake-success-coupon-code">
          <div class="hibake-coupon-its" v-for="cou in order.hasCoupon" :key="cou.id">
            <div class="hibake-coupon-its-code" v-if="cou.draw_status === 2">
              兑换券码：{{ cou?.code }}
            </div>
            <div class="hibake-coupon-its-code" v-else>
              处理中
            </div>
            <div class="hibake-success-copy">
              <el-button type="warning" color="#C8B29F" style="color: #ffffff" @click="copyText(cou?.code)"
                         v-if="type?.type === 'hibake'">复制券码
              </el-button>
              <el-button type="warning" color="#56B6C2" style="color: #ffffff" @click="copyText(cou?.code)"
                         v-if="type?.type === 'waijiaoguan'">复制券码
              </el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="options">
      <!--      order?.couponItems?.business !== 'hbwl' && order?.couponItems?.business !== 'lsq' && order?.couponItems?.business !== 'haoll' && order?.couponItems?.business !== 'atl' && order?.couponItems?.business !== 'hibake'-->
      <el-button :type="type.login === 'xm_air'?'primary':'danger'" style="margin-bottom: 10px" round
                 @click="router.replace({name:'store'})"
                 v-if="!['hbwl','lsq','haoll','atl','hibake','waijiaoguan'].find(item => item === order?.couponItems?.business)">
        查看适用门店列表
      </el-button>
      <el-button :type="type.login === 'xm_air'?'primary':'danger'" style="margin-bottom: 10px" round
                 @click="gotoUrl('https://pay.jifen360.com/third/scal-app/morestore.html?type=coupon&cid=127')"
                 v-if="order?.couponItems?.business === 'lsq'">
        查看适用门店列表
      </el-button>
      <el-button :type="type.login === 'xm_air'?'primary':'danger'" style="margin-bottom: 10px" round
                 @click="router.replace({name:'order'})">
        查看订单
      </el-button>
      <el-button :type="type.login === 'xm_air'?'primary':'danger'" style="margin-bottom: 10px" round
                 @click="router.replace({name:'home'})">
        返回首页
      </el-button>
    </div>
  </el-scrollbar>
  <el-empty description="订单查询中" v-else/>
</template>

<style scoped lang="less">
.page-success {
  height: 100vh;
  //background: var(--theme-copyright-color);

  .order-details-header {
    height: 240px;
    background: var(--btn-color);
    color: #ffffff;

    .order-details-header-info {
      display: flex;
      justify-content: center;
      padding: 30px 0;
      align-items: center;

      .icon-pay {
        width: 65px;
        height: 65px;
        margin-right: 20px;
      }
    }

    .border-icon {
      //width: 100%;
      height: 10px;
      background-color: rgba(0, 0, 0, .25);
      border-radius: 10px;
      margin: 0 20px;
    }
  }

  .order-info {
    box-sizing: border-box;
    //padding: 20px;
    background: #ffffff;
    box-shadow: var(--el-box-shadow);
    margin: -109px 28px 15px;

    .order-info-title {
      text-align: center;
      line-height: 1.75;
      padding: 20px;
      border-bottom: 1px dashed var(--el-border-color);
      font-weight: 600;
    }

    .order-price {
      display: flex;
      align-items: flex-start;
      justify-content: center;
      font-weight: 600;
      margin: 15px auto;

      .order-face-value {
        display: inline-block;
        margin-top: -10px;
        font-size: 1.75rem;
      }
    }
  }

  .order-qrcode {
    //padding: 30px;
    margin-top: 30px;
    padding-bottom: 30px;
    text-align: center;

    .barcode {
      .el-image {
        height: 45px;
        width: 220px;
      }
    }

    .qrcode {
      width: 100px;
      margin: auto;

      .el-image {
        width: 100px;
      }

      &.hkl-url {
        width: 220px;

        .el-image {
          width: 220px;
        }
      }
    }
  }

  .options {
    margin: 30px;

    .el-button {
      width: 100%;
      margin-right: 0 !important;
      margin-left: 0;
      display: block;
      //line-height: 45px;
      height: 45px;
      background: var(--btn-color);
      border-color: var(--btn-color);
    }
  }
}

.order-info-qrcode-empty {
  width: 120px;
  height: 120px;
  line-height: 120px;
  margin: auto;
  background-color: #f5f7fa;
}

.code-data {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  line-height: 1.75;
  margin-bottom: 10px;

  .code-its {
    flex-basis: 65%;
    width: 55%;
    //超出宽度显示省略号
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    border-bottom: var(--el-border);
    //padding: 5px;

    .el-text {
      border: 1px solid;
      padding: 5px;
      border-radius: 5px;
      display: inline-block;
      font-size: .6rem;
    }
  }
}

.codes {
  background: #F2FBFF;
  box-sizing: border-box;
  padding: 12px;
  border-radius: 10px;

  .code-lst-its {
    & + .code-lst-its {
      margin-top: 15px;
    }

    .code-name {
      margin-bottom: 10px;
      font-size: 1.13rem;
    }
  }
}

.hll-order-codes {
  background: #E4E4E4;
  box-sizing: border-box;
  padding: 10px;
  border-radius: 8px;

  .hll-order-codes-title {
    text-align: center;
    margin-bottom: 10px;
  }


}

.hll-order-codes-its {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #ffffff;
  box-sizing: border-box;
  padding: 10px;
  border-radius: 5px;

  & + .hll-order-codes-its {
    margin-top: 10px;
  }

  .hll-order-code {
    font-size: .8rem;
    //禁止换行
    white-space: nowrap;
    flex-basis: 65%;
    width: 60%;
    //超出宽度显示省略号
    overflow: hidden;
    text-overflow: ellipsis;

    .el-text {
      font-size: .8rem;
    }
  }
}

.hibake-success-box {
  box-sizing: border-box;
  padding: 15px;
  text-align: justify;

  .hibake-success-coupon-code {
    margin-top: 15px;
  }

  .hibake-coupon-its {
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
    padding: 5px;
    border: 1px solid var(--success-border-color);
    border-radius: 5px;

    .hibake-coupon-its-code {
      flex-basis: 65%;
      width: 60%;
      //超出宽度显示省略号
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      color: var(--btn-color);
      font-size: .8rem;
    }

    & + .hibake-coupon-its {
      margin-top: 10px;
    }
  }
}
</style>
